import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Pipe({
  name: 'currencyFormatSimple'
})
export class CurrencyFormatSimplePipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: number): SafeHtml {
    if (typeof value === 'number') {
      const arrNumb = value.toLocaleString('de-DE').split(',').shift();
      // NOSONAR: Bypassing security is safe here because the input is strictly a number and is controlled.
      return this.sanitized.bypassSecurityTrustHtml(`$ ${arrNumb}`);
    } else {
      return '';
    }
  }
}
